import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Close modal on escape key
    document.addEventListener('keydown', this.handleEscape.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape.bind(this))
  }

  close() {
    this.modalTarget.classList.add('hidden');
    this.modalTarget.classList.remove('flex');
  }

  closeBackground(event) {
    if (event.target === this.modalTarget) {
      this.close();
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
}
